import React from 'react';

const AnimatedBackground = () => {
  return (
    <div className="fixed inset-0 -z-10 overflow-hidden" style={{ willChange: 'transform' }}>
      {/* Gradient Base */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-white to-indigo-50"></div>
      
      {/* Animated Geometric Shapes */}
      <div className="absolute inset-0">
        {/* Floating Key Icons - Optimized */}
        <div className="absolute top-20 left-10 w-8 h-8 bg-blue-200/20 rounded-lg animate-pulse opacity-30 transform rotate-12" style={{ willChange: 'opacity' }}></div>
        <div className="absolute top-40 right-20 w-6 h-6 bg-green-200/20 rounded-full animate-bounce opacity-20 animation-delay-1000" style={{ willChange: 'transform' }}></div>
        <div className="absolute bottom-32 left-1/4 w-10 h-10 bg-orange-200/15 rounded-full animate-pulse animation-delay-2000 opacity-25" style={{ willChange: 'opacity' }}></div>
        <div className="absolute top-1/3 right-1/3 w-4 h-4 bg-purple-200/20 rounded-lg animate-bounce animation-delay-3000 opacity-30" style={{ willChange: 'transform' }}></div>
        
        {/* Moving Car Silhouettes */}
        <div className="absolute top-1/4 left-20 w-12 h-6 bg-gray-200/20 rounded-full animate-float opacity-25"></div>
        <div className="absolute bottom-1/4 right-32 w-10 h-5 bg-blue-200/20 rounded-lg animate-float-reverse opacity-30 animation-delay-2000"></div>
        
        {/* Large Decorative Circles */}
        <div className="absolute -top-20 -left-20 w-80 h-80 bg-gradient-to-r from-blue-100/20 to-purple-100/20 rounded-full blur-3xl animate-pulse-slow"></div>
        <div className="absolute -bottom-20 -right-20 w-96 h-96 bg-gradient-to-l from-green-100/15 to-blue-100/15 rounded-full blur-3xl animate-pulse-slow animation-delay-4000"></div>
        
        {/* Tech Circuit Pattern */}
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full h-full opacity-5">
          <svg viewBox="0 0 400 400" className="w-full h-full">
            <defs>
              <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
                <path d="M 40 0 L 0 0 0 40" fill="none" stroke="#3B82F6" strokeWidth="0.5"/>
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#grid)" />
          </svg>
        </div>
        
        {/* Floating Lock Elements */}
        <div className="absolute top-16 right-1/4 w-5 h-5 bg-red-200/30 rounded-sm animate-spin-slow opacity-25"></div>
        <div className="absolute bottom-20 left-1/3 w-7 h-7 bg-yellow-200/25 rounded-full animate-pulse animation-delay-1500 opacity-30"></div>
        
        {/* Dynamic Lines */}
        <div className="absolute top-0 left-1/4 w-px h-32 bg-gradient-to-b from-transparent via-blue-200/40 to-transparent animate-slide-down"></div>
        <div className="absolute bottom-0 right-1/3 w-px h-40 bg-gradient-to-t from-transparent via-green-200/40 to-transparent animate-slide-up animation-delay-2000"></div>
      </div>
      
      {/* Noise Texture Overlay */}
      <div 
        className="absolute inset-0 opacity-[0.015] mix-blend-multiply"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`,
        }}
      ></div>
    </div>
  );
};

export default AnimatedBackground;